import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';

export interface ILocationModalProps extends React.PropsWithChildren {
  title: string;
  header: React.ReactNode;
  onClose: () => void;
}

export const LocationModal: React.FC<ILocationModalProps> = ({ title, header, children, onClose }) => {
  return (
    <ModalWindow open height="100%" width="100%" fixed title={title} header={header} onClose={onClose}>
      {children}
    </ModalWindow>
  );
};
